import request from "@/utils/request";

// 登录
export function login(data) {
  return request({
    url: "/data/login/loginverify",
    method: "post",
    data
    // post请求接口后面拼接参数
    //   params: {
    //     currentOpenId: 'currentOpenId',
    //     currentCompanyOpenId: 'currentCompanyOpenId'
    //   }
  });
}

// 退出
export function logout(data) {
  return request({
    url: "/data/login/logout",
    method: "post",
    data
  });
}

// 文件上传
export function upload_file(data) {
  return request({
    url: "/FjSUPmONcn.php/ajax/upload",
    // url: "/addons/alioss/index/params",aa
    method: "post",
    data
  });
}

// 消息通知
export function news_list(data) {
  return request({
    url: "/data/news/news_list",
    method: "post",
    data
  });
}

// 其余费用支出--列表
export function z_index(data) {
  return request({
    url: "/data/otherfees/z_index",
    method: "post",
    data
  });
}

// 其余费用支出--添加
export function z_add(data) {
  return request({
    url: "/data/otherfees/z_add",
    method: "post",
    data
  });
}

// 其余费用收入--列表
export function index(data) {
  return request({
    url: "/data/otherfees/index",
    method: "post",
    data
  });
}

// 其余费用收入--添加
export function add(data) {
  return request({
    url: "/data/otherfees/add",
    method: "post",
    data
  });
}

// 下载周稿
export function xz_file(data) {
  return request({
    url: "/data/uploadfile/xz_file",
    method: "post",
    data
  });
}

// 金主写手的导入
export function import_xlsx(data) {
  return request({
    url: "/data/uploadfile/import",
    method: "post",
    data
  });
}



// WEBPACK FOOTER //
// ./src/utils/api.js